import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getUserNote, setUserNote } from '@/lib/userNotes';

/** Right pane of the full-profile dialog: activity (bio / empty state) + a
 *  private per-device note (Discord "Заметка — видна только вам"). */
export function ProfileSidePane(props: { userId: string; name: string; bio: string | null }) {
  const { t } = useTranslation();
  const [note, setNote] = useState(() => getUserNote(props.userId));
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-5 border-t border-separator md:border-l md:border-t-0 bg-default/20 p-5">
      <div>
        <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-ink-muted">
          {t('prof.sidePane.activity')}
        </div>
        {props.bio ? (
          <p className="whitespace-pre-line text-sm leading-relaxed text-ink">{props.bio}</p>
        ) : (
          <p className="text-sm leading-relaxed text-ink-muted">
            {t('prof.sidePane.noActivity', { name: props.name })}
          </p>
        )}
      </div>
      <div className="mt-auto">
        <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-ink-muted">
          {t('prof.sidePane.note')}
        </div>
        <textarea
          aria-label={t('prof.sidePane.note')}
          value={note}
          onChange={(e) => {
            setNote(e.target.value);
            setUserNote(props.userId, e.target.value);
          }}
          placeholder={t('prof.sidePane.notePlaceholder')}
          rows={4}
          className="w-full resize-none rounded-lg border border-separator bg-surface px-3 py-2 text-sm text-ink placeholder:text-ink-muted focus:border-accent focus:outline-none"
        />
      </div>
    </div>
  );
}
